import React from 'react'
import { connect } from 'react-redux'
import { Howl, Howler } from 'howler'
import { rxSound } from '../lib/rx_subject'

const sounds = ['push', 'correct', 'wrong', 'roundwin', 'open', 'timeup', 'chat']

const howls = {}

const loadHowls = () => {
  sounds.forEach(sound => {
    howls[sound] = new Howl({
      src: [`/snd/${sound}.mp3`]
    })
  })
}

const playSound = async name => {
  return new Promise((resolve, reject) => {
    howls[name]
      .once('end', () => { resolve() })
      .play()
  })
}

const Sound = ({ setting: { personal: { sound } } }) => {
  React.useEffect(() => {
    loadHowls()
  }, [])

  React.useEffect(() => {
    const playSounds = async names => {
      for (const name of names) {
        if (name in sound && !sound[name]) {
          continue
        }

        await playSound(name)
      }
    }

    const subscription = rxSound.subscribe(names => {
      playSounds(names)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [sound])

  React.useEffect(() => {
    Howler.volume(sound.volume / 100.0)
  }, [sound])

  return (
    <div />
  )
}

export default connect(
  state => ({
    setting: state.setting
  })
)(Sound)
